<template>
  <div class="app flex-row align-items-center" v-bind:class="classBgImg" @keyup.enter="validateAndSignIn">
    <div class="login-block-logo">
      <img v-if="IsThemeSDS" src="/static/img/logotipo/logo_descricao_sds_branco.png" style="width: 240px;" />
      <img v-else-if="IsThemeCOTEXO" src="/static/clients/cotexo/logo.png" style="width: 280px;" />
      <img v-else-if="IsThemeCONSTAR" src="/static/clients/constar/constar-logo.png" style="width: 380px;" />
      <img v-else src="/static/clients/acelerauto/Logo-Acelerauto-Positivo.png" alt="Logo-Acelerauto" style="width: 200px;"/>
    </div>
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-5">
          <div class="card-group mb-0">
            <div class="card p-4">
              <div class="card-block">
                <h1>{{$lang.Login.TitleForm}}</h1>
                <p class="text-muted">{{$lang.Login.TitleFormDescription}}</p>
                <div class="input-group mb-3">
                  <span class="input-group-addon"><i class="icon-user"></i></span>
                  <b-form-input type="email"
                          id="email"
                          name="email"
                          :placeholder="errors.has('email') ? errors.first('email') : $lang.Login.Email"
                          v-model="credentials.email"
                          v-validate="'required|email'"
                          aria-describedby="emailErrorFeedback"
                          :state="errors.has('email') ? false : getValidationState('email')"
                          @blur.native="getValidationState('email')">
                  </b-form-input>
                </div>
                <div class="input-group mb-4">
                  <span class="input-group-addon"><i class="icon-lock"></i></span>
                  <b-form-input type="password"
                          id="password"
                          name="password"
                          :placeholder="errors.has('password') ? errors.first('password') : $lang.Login.Password"
                          v-model="credentials.password"
                          data-vv-as="senha"
                          v-validate="'required'"
                          aria-describedby="passwordErrorFeedback"
                          :state="errors.has('password') ? false : getValidationState('password')"
                          @blur.native="getValidationState('password')">
                  </b-form-input>
                </div>
                <div class="row">
                  <div class="col-6 text-left">
                    <router-link :to="{ name: 'LostPassword' }" class="btn btn-link px-0">{{$lang.Login.LostPassowrd}}</router-link>
                  </div>
                  <div class="col-6 text-right">
                    <button type="button" class="btn btn-third px-4" @click="validateAndSignIn"><i class="fa fa-sign-in"></i> {{$lang.Login.ButtonEnter}}</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row justify-content-center pt-3 login-version">
        <a href="http://jeugenio.com.br" target="_blank"  style="color: #fff;">Powered by JEUGENIO IT &nbsp;-&nbsp; {{$lang.Login.LabelVersion}} {{version}}</a>
      </div>

    </div>
  </div>
</template>

<script>
import Authentication from './Authentication.js'
export default Authentication

</script>



// WEBPACK FOOTER //
// src/views/public/auth/Authentication.vue